// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arrow-img[data-v-df80c8cc]{transition:all .3s linear}.arrow-img-collapsed[data-v-df80c8cc]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
